import "./Files.css";
import { Trans, useTranslation } from "react-i18next";
import {
  Checklist,
  Clear,
  DeleteForever,
  InsertDriveFile,
  OpenInBrowser,
} from "@mui/icons-material";
import Button from "../Button/Button";
import EmptySection from "../EmptySection/EmptySection";
import { FormLoader } from "../Form/Form";
import { capitalize } from "../../../utils";
import { useToastsDispatch } from "../Toasts/ToastsContext";
import { useEffect, useRef, useState } from "react";

export default function Files({
  files = [
    {
      id: 0,
      name: "document 1",
      date: new Date(),
      url: "",
      onDelete: null,
    },
    {
      id: 1,
      name: "document 2",
      date: new Date(),
      url: "",
      onDelete: null,
    },
  ],
  loadingFiles = false,
  sortByDate = false,
}) {
  const { t } = useTranslation(["common", "vault"]);

  const [enabledFilesDeletion] = useState(false);
  const FilesDeletionContainerRef = useRef(null);

  const sortByDescendingDate = (a, b) =>
    sortByDate && (a.date < b.date ? 1 : -1);

  return loadingFiles ? (
    <FormLoader />
  ) : files.length === 0 ? (
    <EmptySection icon={<Checklist />} text={t("vault:common.files.none")} />
  ) : (
    <div className="Files" ref={FilesDeletionContainerRef}>
      <div className="Files-container">
        {files.sort(sortByDescendingDate).map((file) => (
          <div className="Files-container-File-wrapper" key={file.id}>
            <MyFile {...file} />
          </div>
        ))}
      </div>
      {enabledFilesDeletion && (
        <FilesDeletion files={files} containerRef={FilesDeletionContainerRef} />
      )}
    </div>
  );
}

function FilesDeletion({ files, containerRef }) {
  const [deleteAllConfirm, setDeleteAllConfirm] = useState(false);

  const handleDeleteAll = () => {
    for (const file of files) {
      file.onDelete();
    }
    setDeleteAllConfirm(false);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        deleteAllConfirm &&
        containerRef.current &&
        !containerRef.current.contains(e.target)
      ) {
        setDeleteAllConfirm(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [deleteAllConfirm]);

  return (
    files.length > 1 && (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          alignItems: "center",
        }}
      >
        {deleteAllConfirm && (
          <Button
            variant={"link"}
            style={{ color: "var(--color-neutral-1)" }}
            text="Annuler"
            onClick={() => setDeleteAllConfirm(false)}
          />
        )}
        <Button
          variant={"link"}
          {...(!deleteAllConfirm
            ? {
                text: "Supprimer tout",
                style: { color: "var(--color-neutral-1)" },
                onClick: () => setDeleteAllConfirm(true),
              }
            : {
                text: "Confirmer la suppression",
                style: { color: "var(--color-error-1)" },
                onClick: handleDeleteAll,
              })}
        />
      </div>
    )
  );
}

export function MyFile({ name, url, onDelete, card }) {
  const dispatchToast = useToastsDispatch();
  const { t } = useTranslation(["common", "vault"]);

  return (
    <div className={["File", card ? "Card" : ""].filter(Boolean).join(" ")}>
      {card && (
        <div className="File-icon">
          <InsertDriveFile />
        </div>
      )}
      <div className="File-text">{name}</div>
      <div className="File-buttons">
        {!card && (
          <Button
            icon={<OpenInBrowser />}
            url={url}
            isExternalURL={true}
            title={t("common:show")}
            // New tab - bug
          />
        )}
        <Button
          icon={card ? <Clear /> : <DeleteForever />}
          title={card ? "" : t("common:delete")}
          onClick={async () => {
            const done = await onDelete();
            const toastVariant = done ? "success" : "error";
            const subheading = (
              <Trans
                t={t}
                i18nKey={`vault:common.toasts.fileDelete${capitalize(toastVariant)}.subheading`}
                values={{ document: name }}
              />
            );
            !card &&
              dispatchToast({
                type: "add",
                variant: toastVariant,
                heading: t(
                  `vault:common.toasts.fileDelete${capitalize(toastVariant)}.heading`,
                ),
                subheading: subheading,
              });
          }}
        />
      </div>
    </div>
  );
}
